import { Component, Input } from '@angular/core';
import { TooltipWrapperComponent } from '../tooltip-wrapper/tooltip-wrapper.component';
import { PriceType } from '../../models/economy-models';

@Component({
  selector: 'app-price-type-indicator',
  standalone: true,
  imports: [TooltipWrapperComponent],
  templateUrl: './price-type-indicator.component.html',
  styleUrls: ['./price-type-indicator.component.scss', '../../tier-list-tab/tier-tab-common.scss']
})
export class PriceTypeIndicatorComponent {
  @Input() priceType?: PriceType;
  @Input() isUnique = false;
  @Input() disabled = false;

  readonly PriceType = PriceType;
}
